import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AILauncher from "./components/AI/AILauncher";

import BrixiGoLandingPage from "./components/pages/BrixiGoLandingPage";
import PricingPage from "./components/pages/PricingPage";
import AboutUsPage from "./components/pages/AboutUsPage";
import ContactUsPage from "./components/pages/ContactUsPage";
import CancellationRefundPolicyPage from "./components/pages/CancellationRefundPolicyPage";
import PrivacyPolicyPage from "./components/pages/PrivacyPolicyPage";
import ServiceDeliveryPolicyPage from "./components/pages/ServiceDeliveryPolicyPage";
import TermsOfUsePage from "./components/pages/TermsOfUsePage";
import PaymentSuccessPage from "./components/pages/PaymentSuccessPage";
import PaymentFailedPage from "./components/pages/PaymentFailedPage";
import SubscriptionExpiredPage from "./components/pages/SubscriptionExpiredPage";
import BookADemoPage from "./components/pages/BookADemoPage";
import BookDemoSuccessPage from "./components/pages/BookDemoSuccessPage";
import ScheduleDemoPage from "./components/pages/ScheduleDemoPage";
import Dashboard from "./components/pages/Dashboard";
import DashboardActivityPage from "./components/pages/DashboardActivityPage";
import Form16 from "./components/pages/Form16";
import Layout from "./components/layout/Layout";
import Protected from "./components/Protected";
import ProtectedRoute from "./components/ProtecteRoute";
import Approvals from "./components/pages/Approvals/Approvals";
import Loans from "./components/pages/Loans/Loans";
import PeopleHubPage from "./Moduels/Employees/PeopleHubPage";
import EmployeeProfilePage from "./Moduels/Employees/EmployeeProfile/EmployeeProfilePage";
import OrgHierarchyPage from "./Moduels/Employees/OrgHierarchyPage";
import OrgLocationStructurePage from "./Moduels/Employees/OrgLocationStructurePage";
import EmployeeCreate from "./Moduels/Employees/EmployeeCreate";
import EmployeeForm from "./Moduels/Employees/EmployeeForm";
import EmployeeImportGuide from "./Moduels/Employees/EmployeeImportGuide";
import NoticeBoard from "./components/layout/NoticeBoard";
import Help from "./components/pages/Help";
import AttendanceLayout from "./components/pages/Attendance/AttendanceLayout";
import { AttendanceWeeklyAdmin } from "./components/pages/Attendance/weekly/AttendanceHome";
import MarkAttendancePage from "./Moduels/attendance/MarkAttendancePage";
import PayrollHome from "./Moduels/Salary/PayrollHome";
import SalaryTemplatess from "./Moduels/Salary/SalaryTemplates";
import EmployeeSalaryStructure from "./Moduels/Salary/EmployeeSalaryStructure";
import CtcSalaryPlanner from "./Moduels/Salary/tools/CtcSalaryPlanner";
import Setup from "./Moduels/Setup/setup";
import AttendanceReportsPage from "./Moduels/reports/AttendanceReportsPage";
import EmployeeReportsPage from "./Moduels/reports/EmployeeReportsPage";
import LeaveReportsPage from "./Moduels/reports/LeaveReportsPage";
import PayrollReportsWorkspace from "./Moduels/reports/PayrollReportsWorkspace";
import EmployeeSalaryRegister from "./Moduels/reports/EmployeeSalaryRegister";
import StatutoryReportsWorkspace from "./Moduels/reports/statutory/StatutoryReportsWorkspace";
import EsiReportsWorkspace from "./Moduels/reports/esi/EsiReportsWorkspace";
import LeaveApproval from "./components/pages/Attendance/LeaveApproval";
import AttendanceCalendarMaster from "./components/pages/Attendance/AttendanceCalendarMaster";
import OtHoursAllocationPage from "./components/pages/Attendance/OtHoursAllocationPage";
import { RedirectToAttendanceCalendarMaster } from "./components/pages/Attendance/RedirectToAttendanceCalendarMaster";
import WfAttendanceSetup from "./components/pages/Attendance/WfAttendanceSetup";
import AttendanceConfigurationPage from "./components/pages/Attendance/AttendanceConfigurationPage";
import WfOperationalOnboarding from "./components/pages/Attendance/WfOperationalOnboarding";
import WfShiftManagement from "./components/pages/Attendance/WfShiftManagement";
import WfSourceConfig from "./components/pages/Attendance/WfSourceConfig";
import WfExceptions from "./components/pages/Attendance/WfExceptions";
import WfApprovals from "./components/pages/Attendance/WfApprovals";
import WfPolicies from "./components/pages/Attendance/WfPolicies";
import WfLabels from "./components/pages/Attendance/WfLabels";
import WfLivePunches from "./components/pages/Attendance/WfLivePunches";
import WfRosterBoard from "./components/pages/Attendance/WfRosterBoard";
import RosterPlannerGuidePage from "./components/pages/Attendance/RosterPlannerGuidePage";
import WfAttendanceDashboard from "./components/pages/Attendance/WfAttendanceDashboard";
import WfDevices from "./components/pages/Attendance/WfDevices";
import WfEmployeeDeviceMapping from "./components/pages/Attendance/WfEmployeeDeviceMapping";
import WfOpsConsole from "./components/pages/Attendance/WfOpsConsole";
import WfPolicyTrace from "./components/pages/Attendance/WfPolicyTrace";
import LeaveLayout from "./components/pages/Leave/LeaveLayout";
import LeaveDashboard from "./components/pages/Leave/LeaveDashboard";
import HolidayCalendarPage from "./components/pages/Leave/HolidayCalendarPage";
import AttendanceTablePage from "./Moduels/attendance/AttendanceTablePage";
import BankPayments from "./Moduels/Bank/BankPayment";
import BankChangeRequestQueue from "./Moduels/Bank/BankChangeRequestQueue";
import BankTemplateAdmin from "./Moduels/Bank/BankTemplateAdmin";
import BankResponseImportPage from "./Moduels/Bank/BankResponseImportPage";
import DisbursementDashboard from "./Moduels/Bank/DisbursementDashboard";
import DisbursementReports from "./Moduels/Bank/DisbursementReports";
import PfSettings from "./Moduels/statutorySetup/PfSettings";
import EsiSettings from "./Moduels/statutorySetup/EsiSettings";
import ProfessionalTaxSettings from "./Moduels/statutorySetup/ProfessionalTaxSettings";
import LabourWelfareFundSettings from "./Moduels/statutorySetup/LabourWelfareFundSettings";
import Audit from "./Moduels/Audit/AuditLogViewer";
import ReconciliationConsole from "./Moduels/Reconciliation/ReconciliationConsole";
import FraudConsole from "./Moduels/Fraud/FraudConsole";
import EventsConsole from "./Moduels/Events/EventsConsole";
import AuthProvider from "./Moduels/Context/AuthContext";
import OnboardingProvider from "./Moduels/Context/OnboardingContext";
import FoundationSetupProvider from "./Moduels/Context/FoundationSetupContext";
import SetupProgressProvider from "./Moduels/Context/SetupProgressContext";
import OrgProfileProvider from "./Moduels/Context/OrgProfileContext";
import OrgProfileWizard from "./components/setup/OrgProfileWizard";
import { ToastProvider } from "./Moduels/Context/ToastContext";
import ResetPassword from "./components/pages/ResetPassword";
import SocialAuthCallback from "./components/pages/SocialAuthCallback";
import PayrollProcessHub from "./Moduels/payroll/PayrollProcessHub";
import PayrollRunsLayout from "./Moduels/payroll/PayrollRunsLayout";
import PayrollRunsHub from "./Moduels/payroll/PayrollRunsHub";
import PayrollRunsCreate from "./Moduels/payroll/PayrollRunsCreate";
import PayrollTraceViewer from "./Moduels/payroll/PayrollTraceViewer";
import PayrollBatchProcess from "./Moduels/payroll/PayrollBatchProcess";
import PayrollSummary from "./Moduels/payroll/PayrollSummary";
import SalaryStatement from "./Moduels/payroll/SalaryStatement";
import TdsSummary from "./Moduels/payroll/TdsSummary";
import PayslipViewer from "./Moduels/Payslip/PayslipViewer";
import MyAttendancePage from "./Moduels/attendance/MyAttendancePage";
import AttendanceDashboardGate from "./components/pages/Attendance/AttendanceDashboardGate";
import AttendanceIndexRedirect from "./components/pages/Attendance/AttendanceIndexRedirect";
import PayrollLifecycle from "./Moduels/payroll/PayrollLifecycle";
import SalaryV2Home from "./Moduels/Salary/v2/SalaryV2Home";
import ExtraWorkPremiumOvertimePage from "./Moduels/Salary/v2/ExtraWorkPremiumOvertimePage";
import OvertimeWorksPage from "./Moduels/Salary/v2/OvertimeWorksPage";
import OvertimeFormulaBuilderPage from "./Moduels/Salary/v2/OvertimeFormulaBuilderPage";
import PayrollCalendarPage from "./Moduels/Salary/v2/PayrollCalendarPage";
import SalaryComponentsHub from "./Moduels/Salary/v2/enterprise/SalaryComponentsHub";
import SalaryComponentEditorPage from "./Moduels/Salary/v2/enterprise/SalaryComponentEditorPage";
import PayrollSetupWizard from "./Moduels/Salary/v2/PayrollSetupWizard";
import SalaryV2IndexRedirect from "./Moduels/Salary/v2/SalaryV2IndexRedirect";
import PayrollStructuresTab from "./Moduels/Salary/v2/PayrollStructuresTab";
import PayGroupsTab from "./Moduels/Salary/v2/PayGroupsTab";
import SalaryComponentUserGuide from "./Moduels/Salary/v2/enterprise/SalaryComponentUserGuide";
import SalaryQuickStartGuide from "./Moduels/Salary/v2/enterprise/SalaryQuickStartGuide";
import SalaryV2Groups from "./Moduels/Salary/v2/SalaryV2Groups";
import SalaryV2DerivedVariables from "./Moduels/Salary/v2/SalaryV2DerivedVariables";
import SalaryV2Statutory from "./Moduels/Salary/v2/SalaryV2Statutory";
import SalaryFormulaBuilder from "./Moduels/Salary/v2/enterprise/SalaryFormulaBuilder";
import SalaryScheduledEarnings from "./Moduels/Salary/v2/enterprise/SalaryScheduledEarnings";
import SalaryArrearsCorrections from "./Moduels/Salary/v2/enterprise/SalaryArrearsCorrections";
import SalaryBenefitsDeductions from "./Moduels/Salary/v2/enterprise/SalaryBenefitsDeductions";
import SalaryDependencyGraph from "./Moduels/Salary/v2/enterprise/SalaryDependencyGraph";
import SalaryAuditTimeline from "./Moduels/Salary/v2/enterprise/SalaryAuditTimeline";
import SalarySimulatorAdvanced from "./Moduels/Salary/v2/enterprise/SalarySimulatorAdvanced";
import RegisterModal from "./components/pages/RegisterModal";
import SubscriptionAndPlansPage from "./Moduels/Subscription/SubscriptionAndPlansPage";
import { FeaturesProvider } from "./Moduels/Subscription/FeaturesContext";
import UpgradeModal from "./Moduels/Subscription/UpgradeModal";
import SalaryTemplatePipelineEntry from "./Moduels/Salary/v2/enterprise/components/SalaryTemplatePipelineEntry";
import ProfilePage from "./components/pages/ProfilePage";
import FinancialYearSettings from "./components/settings/FinancialYearSettings";
import EmployeeSetupPage, { RedirectLegacyEmployeeSetup } from "./components/settings/EmployeeSetupPage";
import OrganizationSetupPage from "./components/settings/OrganizationSetupPage";
import AttendanceLeaveSetupPage from "./components/settings/AttendanceLeaveSetupPage";
import LeaveSetupPage from "./components/settings/LeaveSetupPage";
import CompOffSettingsPage from "./components/settings/CompOffSettingsPage";
import LeaveEncashmentSettingsPage from "./components/settings/LeaveEncashmentSettingsPage";
import CompOffLeavePage from "./components/pages/Leave/CompOffLeavePage";
import LeaveEncashmentPage from "./components/pages/Leave/LeaveEncashmentPage";
import IamAccessManagement from "./Moduels/IAM/IamAccessManagement";
import SecurityPage from "./components/pages/SecurityPage";
import LifecycleLayout from "./Moduels/Lifecycle/LifecycleLayout";
import LifecycleDashboard from "./Moduels/Lifecycle/LifecycleDashboard";
import LcOnboardingDetail from "./Moduels/Lifecycle/LcOnboardingDetail";
import LcOffboardingDetail from "./Moduels/Lifecycle/LcOffboardingDetail";
import MyOnboarding from "./Moduels/Lifecycle/MyOnboarding";
import MyExit from "./Moduels/Lifecycle/MyExit";
import TdsLayout from "./Moduels/TDS/TdsLayout";
import TdsConfiguration from "./Moduels/TDS/TdsConfiguration";
import EmployeeTaxSetup from "./Moduels/TDS/EmployeeTaxSetup";
import TdsReportsCompliance from "./Moduels/TDS/TdsReportsCompliance";
import TdsUserGuidePage from "./Moduels/TDS/TdsUserGuide";
import TdsRegimeLanding from "./Moduels/TDS/TdsRegimeLanding";
import TdsWorkspace from "./Moduels/TDS/TdsWorkspace";
import TdsIndexRedirect from "./Moduels/TDS/TdsIndexRedirect";
import TdsComplianceCenter from "./Moduels/TDS/compliance/TdsComplianceCenter";

import PayrollAutomation from "./components/pages/Features/PayrollAutomation";
import AttendanceTracking from "./components/pages/Features/AttendanceTracking";
import LeaveManagement from "./components/pages/Features/LeaveManagement";
import ComplianceTds from "./components/pages/Features/ComplianceTds";
import ReportsAnalytics from "./components/pages/Features/ReportsAnalytics";
import EmployeeSelfService from "./components/pages/Features/EmployeeSelfService";
import AttendanceHelpPage from "./components/pages/AttendanceHelpPage";
import EmployeeHelpPage from "./components/pages/EmployeeHelpPage";
import GettingStartedHelpPage from "./components/pages/GettingStartedHelpPage";
import LeaveHelpPage from "./components/pages/LeaveHelpPage";
import SalaryHelpPage from "./components/pages/SalaryHelpPage";
import PayrollHelpPage from "./components/pages/PayrollHelpPage";
import ReportsHelpPage from "./components/pages/ReportsHelpPage";
import SettingsHelpPage from "./components/pages/SettingsHelpPage";
import ComplianceHelpPage from "./components/pages/ComplianceHelpPage";
import CompanyStructureHelpPage from "./components/pages/CompanyStructureHelpPage";
import SupportCenter from "./components/pages/SupportCenter";
import PayrollSupportPage from "./components/pages/PayrollSupportPage";
import PayslipSupportPage from "./components/pages/PayslipSupportPage";
import AttendanceSupportPage from "./components/pages/AttendanceSupportPage";
import LeaveSupportPage from "./components/pages/LeaveSupportPage";
import EmployeeSupportPage from "./components/pages/EmployeeSupportPage";
import SalarySupportPage from "./components/pages/SalarySupportPage";
import LoginAccessSupportPage from "./components/pages/LoginAccessSupportPage";
import ReportsSupportPage from "./components/pages/ReportsSupportPage";
import SettingsLayout from "./components/settings/SettingsLayout";
import SettingsHome from "./components/settings/SettingsHome";
import AllowancesBenefitsHub from "./Moduels/AllowancesBenefits/AllowancesBenefitsHub";
import FuelReimbursementPage from "./Moduels/AllowancesBenefits/FuelReimbursementPage";
import EmployeeFuelRequestPage from "./Moduels/AllowancesBenefits/EmployeeFuelRequestPage";
import AdvanceTakenPage from "./Moduels/AllowancesBenefits/AdvanceTakenPage";

export default function App() {
  return (
    <AuthProvider>
      <OnboardingProvider>
      <FoundationSetupProvider>
      <OrgProfileProvider>
      <SetupProgressProvider>
      <ToastProvider>
        <FeaturesProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<BrixiGoLandingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicyPage />} />
            <Route path="/cancellation-and-refund-policy" element={<Navigate to="/cancellation-refund-policy" replace />} />
            <Route path="/refund-policy" element={<Navigate to="/cancellation-refund-policy" replace />} />
            <Route path="/service-delivery-policy" element={<ServiceDeliveryPolicyPage />} />
            <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
            <Route path="/terms" element={<Navigate to="/terms-of-use" replace />} />
            <Route path="/terms-of-service" element={<Navigate to="/terms-of-use" replace />} />
            <Route path="/about" element={<Navigate to="/about-us" replace />} />
            <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
            <Route path="/login" element={<BrixiGoLandingPage />} />
            <Route path="/auth/social/callback" element={<SocialAuthCallback />} />
            <Route path="/auth/google/callback" element={<SocialAuthCallback />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/registermodal" element={<RegisterModal />} />
            <Route path="/book-demo" element={<BookADemoPage />} />
            <Route path="/book-demo/success" element={<BookDemoSuccessPage />} />
            <Route path="/book-demo/schedule/:token" element={<ScheduleDemoPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/failed" element={<PaymentFailedPage />} />
            <Route path="/subscription/expired" element={<SubscriptionExpiredPage />} />

            <Route
              path="/onboarding/org-profile"
              element={
                <Protected>
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <OrgProfileWizard />
                  </ProtectedRoute>
                </Protected>
              }
            />

            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/activity" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><DashboardActivityPage /></ProtectedRoute>} />

              <Route path="/my-onboarding" element={<ProtectedRoute allowedRoles={["employee", "manager"]}><MyOnboarding /></ProtectedRoute>} />
              <Route path="/my-exit" element={<ProtectedRoute allowedRoles={["employee", "manager"]}><MyExit /></ProtectedRoute>} />

              <Route path="/Setup" element={<ProtectedRoute allowedRoles={["admin"]}><Setup /></ProtectedRoute>} />
              <Route path="/setup" element={<Navigate to="/Setup" replace />} />
              <Route path="/employees" element={<ProtectedRoute allowedRoles={["admin", "hr", "manager", "finance"]}><PeopleHubPage /></ProtectedRoute>} />
              <Route path="/employees/add" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeCreate /></ProtectedRoute>} />
              <Route path="/employees/:employeeId/edit" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeCreate /></ProtectedRoute>} />
              <Route path="/employees/:employeeId" element={<ProtectedRoute allowedRoles={["admin", "hr", "manager", "finance"]}><EmployeeProfilePage /></ProtectedRoute>} />
              <Route path="/employeeInput" element={<Navigate to="/employees?module=employees&view=import" replace />} />
              <Route path="/employee-import/guide" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeImportGuide /></ProtectedRoute>} />
              <Route path="/employeeCreate" element={<Navigate to="/employees/add" replace />} />
              <Route path="/employeeEdit/:employeeId" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeCreate /></ProtectedRoute>} />
              <Route path="/employeeList" element={<Navigate to="/employees" replace />} />
              <Route path="/employeeForm" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeForm /></ProtectedRoute>} />
              <Route path="/employeebulkupload" element={<Navigate to="/employees?module=employees&view=import" replace />} />
              <Route path="/org-hierarchy" element={<ProtectedRoute allowedRoles={["admin", "hr", "manager"]}><OrgHierarchyPage /></ProtectedRoute>} />
              <Route path="/org-structure" element={<ProtectedRoute allowedRoles={["admin"]}><OrgLocationStructurePage /></ProtectedRoute>} />

              <Route path="/payrollhome" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollHome /></ProtectedRoute>} />

              <Route path="/salary/components" element={<Navigate to="/salary-v2/components" replace />} />
              {/* Legacy mistaken path /salary/v2/* → real Salary Engine /salary-v2/* */}
              <Route path="/salary/v2" element={<Navigate to="/salary-v2" replace />} />
              <Route path="/salary/v2/groups" element={<Navigate to="/salary-v2/groups" replace />} />
              <Route path="/salary/v2/derived-variables" element={<Navigate to="/salary-v2/derived-variables" replace />} />
              <Route path="/salary/v2/components" element={<Navigate to="/salary-v2/components" replace />} />
              <Route path="/salary/v2/*" element={<Navigate to="/salary-v2/components" replace />} />
              <Route path="/salary/templates" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><SalaryTemplatess /></ProtectedRoute>} />
              <Route path="/salary/templates/:id" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><SalaryTemplatePipelineEntry /></ProtectedRoute>} />
              <Route path="/salary/preview" element={<Navigate to="/salary-v2/preview" replace />} />
              <Route path="/salary/preview/:id" element={<Navigate to="/salary-v2/preview" replace />} />
              <Route path="/employeesalarystructure" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeSalaryStructure /></ProtectedRoute>} />
              <Route path="/tools/ctc-planner" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><CtcSalaryPlanner /></ProtectedRoute>} />

              <Route
                path="/salary-v2/setup"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr"]}>
                    <PayrollSetupWizard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/salary-v2"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr"]}>
                    <SalaryV2Home />
                  </ProtectedRoute>
                }
              >
                <Route index element={<SalaryV2IndexRedirect />} />
                {/* Legacy /salary-v2/settings → payroll settings page */}
                <Route path="settings" element={<Navigate to="/salary-v2/setup" replace />} />
                <Route path="payroll-calendar" element={<PayrollCalendarPage />} />
                <Route path="extra-work" element={<ExtraWorkPremiumOvertimePage />} />
                <Route path="overtime" element={<OvertimeWorksPage />} />
                <Route path="overtime/formula" element={<OvertimeFormulaBuilderPage />} />
                <Route path="premium" element={<Navigate to="/salary-v2/extra-work" replace />} />
                <Route path="components/new" element={<SalaryComponentEditorPage />} />
                <Route path="components/:componentId/edit" element={<SalaryComponentEditorPage />} />
                <Route path="components" element={<SalaryComponentsHub />} />
                <Route path="structures" element={<PayrollStructuresTab />} />
                <Route path="pay-groups" element={<PayGroupsTab />} />
                <Route path="user-guide" element={<SalaryComponentUserGuide />} />
                <Route path="quick-start" element={<SalaryQuickStartGuide />} />
                <Route path="benefits-deductions" element={<SalaryBenefitsDeductions />} />
                <Route path="groups" element={<SalaryV2Groups />} />
                <Route path="derived-variables" element={<SalaryV2DerivedVariables />} />
                <Route path="formula-builder" element={<SalaryFormulaBuilder />} />
                <Route path="scheduled" element={<SalaryScheduledEarnings />} />
                <Route path="arrears" element={<SalaryArrearsCorrections />} />
                <Route path="statutory" element={<SalaryV2Statutory />} />
                <Route path="simulator" element={<SalarySimulatorAdvanced />} />
                <Route path="dependencies" element={<SalaryDependencyGraph />} />
                <Route path="audit" element={<SalaryAuditTimeline />} />
                <Route path="preview" element={<Navigate to="/salary-v2/simulator" replace />} />
                <Route path="*" element={<Navigate to="/salary-v2/pay-groups" replace />} />
              </Route>

              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/subscription" element={<Navigate to="/settings/subscription" replace />} />
              <Route path="/payments" element={<Navigate to="/settings/subscription?tab=billing" replace />} />
              <Route path="/security" element={<SecurityPage />} />

              <Route
                path="/employee-lifecycle"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "finance", "superadmin", "super_admin"]}>
                    <LifecycleLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<LifecycleDashboard />} />
                <Route path="onboarding/:id" element={<LcOnboardingDetail />} />
                <Route path="offboarding/:id" element={<LcOffboardingDetail />} />
              </Route>

              <Route
                path="/leave"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "manager", "employee"]}>
                    <LeaveLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<LeaveDashboard />} />
                <Route path="approval" element={<Navigate to="/leave?tab=approval" replace />} />
                <Route path="balances" element={<Navigate to="/leave?tab=balances" replace />} />
                <Route path="holidays" element={<Navigate to="/holiday-calendar" replace />} />
                <Route path="analytics" element={<Navigate to="/leave?tab=analytics" replace />} />
                <Route path="admin" element={<Navigate to="/settings/leave-setup" replace />} />
                <Route path="apply" element={<Navigate to="/leave?tab=apply" replace />} />
                <Route path="comp-off" element={<CompOffLeavePage />} />
                <Route path="encashment" element={<LeaveEncashmentPage />} />
              </Route>

              <Route
                path="/holiday-calendar"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "manager", "employee"]}>
                    <AttendanceLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<HolidayCalendarPage />} />
              </Route>

              <Route
                path="/attendance"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "manager", "employee"]}>
                    <AttendanceLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AttendanceIndexRedirect />} />
                <Route
                  path="overview"
                  element={
                    <ProtectedRoute allowedRoles={["admin", "hr", "manager"]}>
                      <AttendanceWeeklyAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route path="home" element={<Navigate to="/attendance" replace />} />
                <Route path="mark" element={<MarkAttendancePage />} />
                <Route path="records" element={<AttendanceTablePage />} />
                <Route path="calendar" element={<Navigate to="/attendance/apply-calendar" replace />} />
                <Route path="calendar-master" element={<RedirectToAttendanceCalendarMaster tab="daily" />} />
                <Route path="holiday-calendar" element={<Navigate to="/holiday-calendar" replace />} />
                <Route path="summary" element={<Navigate to="/reports/attendance" replace />} />
                <Route path="upload" element={<RedirectToAttendanceCalendarMaster tab="import" />} />
                <Route path="bulk" element={<RedirectToAttendanceCalendarMaster tab="import" />} />
                <Route path="apply-calendar" element={<AttendanceCalendarMaster />} />
                <Route
                  path="ot-hours"
                  element={
                    <ProtectedRoute allowedRoles={["admin", "hr"]}>
                      <OtHoursAllocationPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="leave" element={<LeaveApproval />} />
                <Route path="holidays" element={<Navigate to="/holiday-calendar" replace />} />
                <Route path="dashboard" element={<AttendanceDashboardGate />} />
                <Route path="punches" element={<WfLivePunches />} />
                <Route path="workforce" element={<WfAttendanceDashboard />} />
                <Route path="roster" element={<WfRosterBoard />} />
                <Route path="roster/guide" element={<RosterPlannerGuidePage />} />
                <Route path="roster/planner" element={<Navigate to="/attendance/roster" replace />} />
                <Route path="exceptions" element={<WfExceptions />} />
                <Route path="approvals" element={<WfApprovals />} />
                <Route path="setup" element={<ProtectedRoute allowedRoles={["admin"]}><WfAttendanceSetup /></ProtectedRoute>} />
                <Route path="setup-wizard" element={<ProtectedRoute allowedRoles={["admin"]}><WfAttendanceSetup /></ProtectedRoute>} />
                <Route path="configuration" element={<ProtectedRoute allowedRoles={["admin"]}><AttendanceConfigurationPage /></ProtectedRoute>} />
                <Route path="weekly-off" element={<Navigate to="/settings/attendance-leave-setup?tab=weekly-off" replace />} />
                <Route path="onboarding" element={<ProtectedRoute allowedRoles={["admin"]}><WfOperationalOnboarding /></ProtectedRoute>} />
                <Route path="shifts" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><WfShiftManagement /></ProtectedRoute>} />
                <Route path="source-config/:sourceCode" element={<ProtectedRoute allowedRoles={["admin"]}><WfSourceConfig /></ProtectedRoute>} />
                <Route path="policies" element={<ProtectedRoute allowedRoles={["admin"]}><WfPolicies /></ProtectedRoute>} />
                <Route path="freeze" element={<ProtectedRoute allowedRoles={["admin"]}><RedirectToAttendanceCalendarMaster tab="lock" /></ProtectedRoute>} />
                <Route path="devices" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><WfDevices /></ProtectedRoute>} />
                <Route path="employee-device-mapping" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><WfEmployeeDeviceMapping /></ProtectedRoute>} />
                <Route path="policy-trace" element={<WfPolicyTrace />} />
                <Route path="ops" element={<ProtectedRoute allowedRoles={["admin"]}><WfOpsConsole /></ProtectedRoute>} />
                <Route path="labels" element={<ProtectedRoute allowedRoles={["admin"]}><WfLabels /></ProtectedRoute>} />
              </Route>
              {/* Legacy URLs → new paths (bookmarks still work) */}
              <Route path="/attendanceTable" element={<Navigate to="/attendance/records" replace />} />
              <Route path="/attendanceCalendar" element={<Navigate to="/attendance/apply-calendar" replace />} />
              <Route path="/attendanceSummary" element={<Navigate to="/reports/attendance" replace />} />
              <Route path="/attendanceBulkUpload" element={<RedirectToAttendanceCalendarMaster tab="import" />} />
              <Route path="/attendance/upload-attendance" element={<RedirectToAttendanceCalendarMaster tab="import" />} />
              <Route path="/attendanceApplyCalendar" element={<Navigate to="/attendance/apply-calendar" replace />} />
              <Route path="/leaveApproval" element={<Navigate to="/attendance/leave" replace />} />
              <Route path="/attendanceHolidays" element={<Navigate to="/holiday-calendar" replace />} />
              <Route path="/attendanceSetup" element={<Navigate to="/attendance/setup" replace />} />
              <Route path="/attendanceSetupWizard" element={<Navigate to="/attendance/setup-wizard" replace />} />
              <Route path="/attendanceExceptions" element={<Navigate to="/attendance/exceptions" replace />} />
              <Route path="/attendanceApprovals" element={<Navigate to="/attendance/approvals" replace />} />
              <Route path="/attendancePolicies" element={<Navigate to="/attendance/policies" replace />} />
              <Route path="/attendanceLabels" element={<Navigate to="/attendance/labels" replace />} />
              <Route path="/attendancePunches" element={<Navigate to="/attendance/punches" replace />} />
              <Route path="/attendanceWfDashboard" element={<Navigate to="/attendance/dashboard" replace />} />
              <Route path="/attendanceRoster" element={<Navigate to="/attendance/roster" replace />} />
              <Route path="/attendanceDevices" element={<Navigate to="/attendance/devices" replace />} />
              <Route path="/attendanceOps" element={<Navigate to="/attendance/ops" replace />} />
              <Route path="/attendancePolicyTrace" element={<Navigate to="/attendance/policy-trace" replace />} />
              <Route path="/attendanceFreeze" element={<Navigate to="/attendance/apply-calendar?tab=lock" replace />} />
              <Route path="/attendance/home" element={<Navigate to="/attendance" replace />} />
              <Route path="/attendanceWorkforce" element={<Navigate to="/attendance/workforce" replace />} />
              <Route path="/departments" element={<Navigate to="/Setup" replace />} />
              <Route path="/payroll/arrears" element={<Navigate to="/salary-v2/arrears" replace />} />
              <Route path="/reports/compliance" element={<Navigate to="/statutory/pf" replace />} />
              <Route path="/reports" element={<Navigate to="/reports/payroll" replace />} />
              <Route path="/reports/employees" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeReportsPage /></ProtectedRoute>} />
              <Route path="/reports/attendance" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><AttendanceReportsPage /></ProtectedRoute>} />
              <Route path="/reports/leave" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><LeaveReportsPage /></ProtectedRoute>} />
              <Route path="/reports/payroll" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollReportsWorkspace /></ProtectedRoute>} />
              <Route
                path="/reports/payroll/employee-salary-register"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "finance"]}>
                    <EmployeeSalaryRegister />
                  </ProtectedRoute>
                }
              />
              <Route path="/reports/statutory" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><StatutoryReportsWorkspace /></ProtectedRoute>} />
              <Route
                path="/reports/esi"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr", "finance"]}>
                    <EsiReportsWorkspace />
                  </ProtectedRoute>
                }
              />
              <Route path="/register" element={<Navigate to="/reports/payroll" replace />} />
              <Route path="/attendance/summary" element={<Navigate to="/reports/attendance" replace />} />

              <Route
                path="/payroll-process"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr"]}>
                    <PayrollProcessHub />
                  </ProtectedRoute>
                }
              />
              <Route path="/pay-periods" element={<Navigate to="/payroll-process?tab=periods" replace />} />
              <Route path="/process-payroll" element={<Navigate to="/payroll-process?tab=process" replace />} />
              <Route
                path="/payroll-runs"
                element={
                  <ProtectedRoute allowedRoles={["admin", "hr"]}>
                    <PayrollRunsLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<PayrollRunsHub />} />
                <Route path="new" element={<PayrollRunsCreate />} />
              </Route>
              <Route path="/payroll-history" element={<Navigate to="/payroll-runs" replace />} />
              <Route path="/payroll/:id/trace" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollTraceViewer /></ProtectedRoute>} />
              <Route path="/payroll-batch" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollBatchProcess /></ProtectedRoute>} />
              <Route path="/summary" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollSummary /></ProtectedRoute>} />
              <Route path="/salary-statement" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><SalaryStatement /></ProtectedRoute>} />
              <Route path="/tds-summary" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><TdsSummary /></ProtectedRoute>} />
              <Route path="/payslip" element={<ProtectedRoute allowedRoles={["admin", "hr", "manager", "employee"]}><PayslipViewer /></ProtectedRoute>} />
              <Route path="/payslips" element={<Navigate to="/payslip?tab=bulk" replace />} />
              <Route
                path="/my-attendance"
                element={
                  <ProtectedRoute allowedRoles={["employee"]}>
                    <MyAttendancePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-fuel"
                element={
                  <ProtectedRoute allowedRoles={["employee"]}>
                    <EmployeeFuelRequestPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/payroll-finalize" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PayrollLifecycle /></ProtectedRoute>} />

              <Route path="/bank" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><BankPayments /></ProtectedRoute>} />
              <Route path="/bank/dashboard" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><DisbursementDashboard /></ProtectedRoute>} />
              <Route path="/bank/reports" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><DisbursementReports /></ProtectedRoute>} />
              <Route path="/bank/change-requests" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><BankChangeRequestQueue /></ProtectedRoute>} />
              <Route path="/bank/templates" element={<ProtectedRoute allowedRoles={["admin"]}><BankTemplateAdmin /></ProtectedRoute>} />
              <Route path="/bank/response-import" element={<ProtectedRoute allowedRoles={["admin", "finance"]}><BankResponseImportPage /></ProtectedRoute>} />
              <Route path="/statutory/pf" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PfSettings /></ProtectedRoute>} />
              <Route path="/statutory/esi" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EsiSettings /></ProtectedRoute>} />
              <Route path="/statutory/pt" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><ProfessionalTaxSettings /></ProtectedRoute>} />
              <Route path="/statutory/lwf" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><LabourWelfareFundSettings /></ProtectedRoute>} />
              <Route path="/statutory" element={<Navigate to="/statutory/pf" replace />} />
              <Route path="/statutorytax" element={<Navigate to="/statutory/pf" replace />} />
              <Route path="/audit" element={<ProtectedRoute allowedRoles={["admin"]}><Audit /></ProtectedRoute>} />

              <Route
                path="/reconciliation"
                element={
                  <ProtectedRoute allowedRoles={["admin", "finance"]}>
                    <ReconciliationConsole />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fraud"
                element={
                  <ProtectedRoute allowedRoles={["admin", "finance"]}>
                    <FraudConsole />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/events"
                element={
                  <ProtectedRoute allowedRoles={["admin", "finance"]}>
                    <EventsConsole />
                  </ProtectedRoute>
                }
              />

              <Route path="/approvals" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><Approvals /></ProtectedRoute>} />
              <Route path="/loans" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><Loans /></ProtectedRoute>} />
              <Route path="/form16" element={<Form16 />} />
              <Route path="/tax" element={<Navigate to="/settings/tds" replace />} />
              {/* /settings/tds routes moved to Settings workspace */}
              <Route path="/noticeboard" element={<NoticeBoard />} />
              <Route path="/help" element={<Help />} />
              <Route path="/help/attendance" element={<AttendanceHelpPage />} />
              <Route path="/help/employees" element={<EmployeeHelpPage />} />
              <Route path="/help/getting-started" element={<GettingStartedHelpPage />} />
              <Route path="/help/leave" element={<LeaveHelpPage />} />
              <Route path="/help/salary" element={<SalaryHelpPage />} />
              <Route path="/help/payroll" element={<PayrollHelpPage />} />
              <Route path="/help/reports" element={<ReportsHelpPage />} />
              <Route path="/help/settings" element={<SettingsHelpPage />} />
              <Route path="/help/compliance" element={<ComplianceHelpPage />} />
              <Route path="/help/company-structure" element={<CompanyStructureHelpPage />} />
              <Route path="/support" element={<SupportCenter />} />
              <Route path="/support/payroll" element={<PayrollSupportPage />} />
              <Route path="/support/payslip" element={<PayslipSupportPage />} />
              <Route path="/support/attendance" element={<AttendanceSupportPage />} />
              <Route path="/support/leave" element={<LeaveSupportPage />} />
              <Route path="/support/employee" element={<EmployeeSupportPage />} />
              <Route path="/support/salary" element={<SalarySupportPage />} />
              <Route path="/support/login" element={<LoginAccessSupportPage />} />
              <Route path="/support/reports" element={<ReportsSupportPage />} />

              {/* Settings workspace — same app shell as other pages (main sidebar visible) */}
              <Route element={<SettingsLayout />}>
                <Route path="/settings" element={<SettingsHome />} />
                <Route path="/settings/subscription" element={<ProtectedRoute allowedRoles={["admin"]}><SubscriptionAndPlansPage /></ProtectedRoute>} />
                <Route path="/settings/attendance-leave-setup" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><AttendanceLeaveSetupPage /></ProtectedRoute>} />
                <Route path="/settings/attendance/comp-off" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><CompOffSettingsPage /></ProtectedRoute>} />
                <Route path="/settings/leave-setup" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><LeaveSetupPage /></ProtectedRoute>} />
                <Route path="/settings/leave/encashment" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><LeaveEncashmentSettingsPage /></ProtectedRoute>} />
                <Route path="/settings/organization" element={<Navigate to="/settings/organization/company-profile" replace />} />
                <Route path="/settings/organization/company-profile" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><OrganizationSetupPage section="company-profile" /></ProtectedRoute>} />
                <Route path="/settings/organization/structure" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><OrganizationSetupPage section="structure" /></ProtectedRoute>} />
                <Route path="/settings/organization/company-structure" element={<Navigate to="/settings/organization/structure" replace />} />
                <Route path="/settings/organization/financial-year" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><FinancialYearSettings /></ProtectedRoute>} />
                <Route path="/settings/organization/branches" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><OrganizationSetupPage section="branches" /></ProtectedRoute>} />
                <Route path="/settings/organization/departments" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><OrganizationSetupPage section="departments" /></ProtectedRoute>} />
                <Route path="/settings/organization/designations" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><OrganizationSetupPage section="designations" /></ProtectedRoute>} />
                <Route path="/settings/employee-configuration" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EmployeeSetupPage /></ProtectedRoute>} />
                <Route path="/settings/employee-setup" element={<RedirectLegacyEmployeeSetup />} />
                <Route path="/settings/employee-setup/employment-types" element={<Navigate to="/settings/employee-configuration#employee-types" replace />} />
                <Route path="/settings/allowances-benefits" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><AllowancesBenefitsHub /></ProtectedRoute>} />
                <Route path="/settings/allowances-benefits/fuel-reimbursement" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><FuelReimbursementPage /></ProtectedRoute>} />
                <Route path="/settings/allowances-benefits/advance-taken" element={<ProtectedRoute allowedRoles={["admin", "hr", "finance"]}><AdvanceTakenPage /></ProtectedRoute>} />
                <Route path="/settings/security/users-roles" element={<ProtectedRoute allowedRoles={["admin"]}><IamAccessManagement /></ProtectedRoute>} />
                <Route path="/settings/statutory" element={<Navigate to="/settings/statutory/pf" replace />} />
                <Route path="/settings/statutory/pf" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><PfSettings /></ProtectedRoute>} />
                <Route path="/settings/statutory/esi" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><EsiSettings /></ProtectedRoute>} />
                <Route path="/settings/statutory/pt" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><ProfessionalTaxSettings /></ProtectedRoute>} />
                <Route path="/settings/statutory/lwf" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><LabourWelfareFundSettings /></ProtectedRoute>} />
                <Route path="/settings/tds" element={<ProtectedRoute allowedRoles={["admin", "hr"]}><TdsLayout /></ProtectedRoute>}>
                  <Route index element={<TdsIndexRedirect />} />
                  <Route path="start" element={<TdsRegimeLanding />} />
                  <Route path="workspace" element={<TdsWorkspace />} />
                  <Route path="configuration" element={<TdsConfiguration />} />
                  <Route path="employee-tax" element={<EmployeeTaxSetup />} />
                  <Route path="reports" element={<TdsReportsCompliance />} />
                  <Route path="compliance" element={<TdsComplianceCenter />} />
                  <Route path="guide" element={<TdsUserGuidePage />} />
                </Route>
              </Route>
            </Route>

            <Route
              path="/features/payroll-automation"
              element={<PayrollAutomation />}
            />
            <Route
              path="/features/attendance-tracking"
              element={<AttendanceTracking />}
            />
            <Route
              path="/features/leave-management"
              element={<LeaveManagement />}
            />
            <Route
              path="/features/compliance-tds"
              element={<ComplianceTds />}
            />
            <Route
              path="/features/reports-analytics"
              element={<ReportsAnalytics />}
            />
            <Route
              path="/features/employee-self-service"
              element={<EmployeeSelfService />}
            />

          </Routes>
          <UpgradeModal />
          {/* Global Brixigo AI launcher — floating FAB + panel (Ctrl/Cmd+J) */}
          <AILauncher />
        </BrowserRouter>
        </FeaturesProvider>
      </ToastProvider>
      </SetupProgressProvider>
      </OrgProfileProvider>
      </FoundationSetupProvider>
      </OnboardingProvider>
    </AuthProvider>
  );
}
